module.exports = __webpack_public_path__ + "static/img/IMG_20240326_141053.3330f3a8.jpg";